import { ColDef } from '@ag-grid-community/core';

import { rawAttributeColumnRenderer } from '@shared/components/ag-raw-attribute-renderer/ag-raw-attribute-renderer';
import { getCellClassForGroups } from '@shared/utils/ag-cell-class-for-groups';
import { getEncodedAttributeName } from '@shared/utils/get-encoded-attribute-name';

import { QuarterCloseGridConfigContext } from './qc-grid-config-context';

export const qcGetCostCategoryColumn = (ctx: QuarterCloseGridConfigContext) => {
  const isPrimarySelected = !!ctx.attributeConfig.primaryAttribute.attribute_name;
  const isSecondarySelected = !!ctx.attributeConfig.secondaryAttribute.attribute_name;
  const index = isSecondarySelected ? 2 : isPrimarySelected ? 1 : 0;
  const field = getEncodedAttributeName('COST_CATEGORY');
  const name = `Cost Category${isPrimarySelected ? '' : ' *'}`;

  return {
    cellClass: getCellClassForGroups,
    field,
    headerClass: ['text-center'],
    headerName: name,
    pinned: isPrimarySelected ? undefined : 'left',
    ...rawAttributeColumnRenderer(ctx.attributeConfig, name, index),
    columnGroupShow: 'open',
  } satisfies ColDef;
};
